export const SEND_DUPLICATE_OPTIONS = {
    normally: { name: 'Normal', id: 1 },
    toOrigin: { name: 'Original', id: 2 },
    toDifferent: { name: 'Different', id: 3 },
}
